import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import InfoIcon from "@material-ui/icons/Info";
import DeleteIcon from "@material-ui/icons/Delete";

import { useStyles } from "../../../../Components/CSS/TableStyle.css";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import CustomDialogBox from "../../../../Components/CustomDialogBox/CustomDialogBox";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";

class AcademicsBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editStatus: false,
      academicId: "",
      dialogOpen: false,
      notificationOpen: false,
    };
  }

  handleEdit = (academicId) => {
    this.setState({
      editStatus: true,
      academicId,
    });
  };

  handleCancelEdit = () => {
    this.setState({
      editStatus: false,
    });
  };

  handleDialogOpen = (academicId) => {
    this.setState({
      dialogOpen: true,
      academicId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  handleDeleteAcademic = async () => {
    try {
      for (let i = 0; i <= this.props.data.files.length - 1; i++) {
        await Axios.post(
          `${url}/api/uploads/delete/`,
          {
            fileName: this.props.data.files[i],
          },
          {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          }
        );
      }
      const response = await Axios.delete(
        `${url}/api/academics/${this.state.academicId}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Academics deleted successfully") {
        this.handleDialogClose();
        this.handleNotificationOpen();
        this.props.getAcademicFiles();
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleDeleteAcademic();
      }
    }
  };

  showNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        autoHideDuration={1600}
        style={{ top: 80, right: 10 }}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  render() {
    const { classes, index, data } = this.props;
    return (
      <TableRow>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{data.title}</TableCell>
        <TableCell align="center">{data.files.length}</TableCell>
        <TableCell align="center">{data.subject}</TableCell>
        <TableCell align="center">{data.fileCategory}</TableCell>
        <TableCell align="center">
          <Tooltip
            arrow
            title="Details"
            className={classes.tooltip}
            onClick={() =>
              this.props.history.push(
                `/administration/academics/details/${data._id}`
              )
            }
          >
            <InfoIcon />
          </Tooltip>
          <Tooltip
            arrow
            title="Delete"
            className={classes.tooltip}
            onClick={() => this.handleDialogOpen(data._id)}
          >
            <DeleteIcon />
          </Tooltip>
          {this.showNotification()}
        </TableCell>
        <CustomDialogBox
          open={this.state.dialogOpen}
          handleClose={this.handleDialogClose}
          handleDelete={this.handleDeleteAcademic}
        />
      </TableRow>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AcademicsBody)));
